module.exports = __webpack_public_path__ + "img/air.1938b71f.png";